
<p-drawer [(visible)]="showSideBar" position="right" styleClass="cp-drawer">
  <ng-template #header>
    <div class="cp-drawer-header text-center">
      <div class="col text-left">
        <h5 class="cp-drawer-title">{{sidebarTitle}}</h5>
      </div>
      <div class="d-flex justify-content-start" class="notificationtype-div">
        <label>
          <strong>Notification Type</strong>
        </label>
        <p-select style="flex: 1;" name="notificationTypes" [options]="filteredNotificationTypes" optionValue="notificationTypeId"
          placeholder="Select a Notification Type" optionLabel="notificationTypeName" class="pl-2 ml-2"
          [(ngModel)]="selectedNotificationTypeId" (onChange)="loadNotification()" [disabled]="notificationId > 0" />
      </div>
    </div>
  </ng-template>
  <ng-template #content>
    @switch(selectedNotificationTypeId) {
      @case (NotificationTypeEnum.ChangeOrder) {
        <changeorder-notifications #NotificationComp
        (complete)="getCloseStatus($event)" />
      }
      @case (NotificationTypeEnum.Recordables) {
        <recordable-notifications #NotificationComp
        (complete)="getCloseStatus($event)" />
      }
    }
      
    @if (!selectedNotificationTypeId) {
      <div class="cp-drawer-body" >
      </div>
    }

  </ng-template>

  <ng-template #footer>
    @if (!selectedNotificationTypeId) {
      <div class="cp-drawer-footer">
        <!--#region SideBar Buttons  -->
        <div>
          <pcp-commandbar>
            <command-button button-left [text]="ButtonText.Close" [iconClasses]="['fas fa-window-close']"
              (commandClick)="getCloseStatus(false)" />
          </pcp-commandbar>
        </div>
        <!--#endregion -->
      </div>
    } @else {
      <div class="cp-drawer-footer">
        @switch (selectedNotificationTypeId) {
          @case (NotificationTypeEnum.ChangeOrder) {
            <pcp-commandbar *checkAccess="Claims.manage_co_notifications">
              <command-button button-left [text]="ButtonText.Close" [iconClasses]="['fas fa-window-close']"
                (commandClick)="notificationComp()?.onClose()" [enabled]="!notificationComp()?.isNotificationFormDirty()" />
              <command-button button-right [text]="ButtonText.Save" [iconClasses]="['fas fa-check']"
                [enabled]="notificationComp()?.isNotificationFormDirty()" (commandClick)="notificationComp()?.onSave()" />
              <command-button button-right [text]="ButtonText.Cancel" [iconClasses]="['fas fa-undo']"
                [enabled]="notificationComp()?.isNotificationFormDirty()" (commandClick)="notificationComp()?.onCancel()" />
            </pcp-commandbar>
          }
          @case (NotificationTypeEnum.Recordables) {
            <pcp-commandbar>
              <command-button button-left [text]="ButtonText.Close" [iconClasses]="['fas fa-window-close']"
                (commandClick)="notificationComp()?.onClose()" [enabled]="!notificationComp()?.isNotificationFormDirty()" />
              <command-button button-right [text]="ButtonText.Save" [iconClasses]="['fas fa-check']"
                [enabled]="notificationComp()?.isNotificationFormDirty()" (commandClick)="notificationComp()?.onSave()" />
              <command-button button-right [text]="ButtonText.Cancel" [iconClasses]="['fas fa-undo']"
                [enabled]="notificationComp()?.isNotificationFormDirty()" (commandClick)="notificationComp()?.onCancel()" />
            </pcp-commandbar>
          }
        }
      </div>
    }
  </ng-template>

</p-drawer>
@if (showSideBar) {
  <div class="sidebar-mask"></div>
}
